import React from "react";
import { Modal, Row, Col, Table, Badge } from "react-bootstrap";

const ViewCartModal = ({ show, handleClose, IMG_URL, onImageClick }) => {
  const item = show;
  const user = item?.User;
  const product = item?.Product;

  const singleVariant = item?.Product_Variant;
  const doubleVariant = item?.Double_Variant;
  const tripleVariant = item?.Triple_Variant;

  const selectedProductVariant =
    singleVariant ||
    doubleVariant?.Product_Variant ||
    tripleVariant?.Double_Variant?.Product_Variant;

  const selectedDoubleVariant = doubleVariant || tripleVariant?.Double_Variant;

  const getImageUrl = (image) => {
    if (!image) return "";
    return image.startsWith("http") ? image : IMG_URL + image;
  };

  const formatPrice = (price) =>
    price !== null && price !== undefined && price !== "" ? `₹${price}` : "N/A";

  const getVariantName = (variant) =>
    variant?.name ||
    variant?.Metal?.name ||
    variant?.Size?.name ||
    variant?.Diamond?.name ||
    "N/A";

  if (!item) return null;

  return (
    <Modal show={!!item} onHide={handleClose} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Cart Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <h5 className="mb-3">User Details</h5>

        <Row className="mb-4">
          <Col md={4} className="mb-2">
            <strong>Name:</strong>{" "}
            {[user?.name, user?.last_name].filter(Boolean).join(" ") || "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>Email:</strong> {user?.email || "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>Contact No.:</strong> {user?.contact_no || "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>User ID:</strong> {user?.id ?? item?.user_id ?? "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>User Status:</strong>{" "}
            <Badge bg={user?.status ? "success" : "secondary"}>
              {user?.status ? "Active" : "Inactive"}
            </Badge>
          </Col>
        </Row>

        <hr />

        <h5 className="mb-3">Cart Details</h5>

        <Row className="mb-4">
          <Col md={4} className="mb-2">
            <strong>Cart ID:</strong> {item?.id ?? "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>Quantity:</strong> {item?.quantity ?? "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>Added On:</strong>{" "}
            {item?.createdAt
              ? new Date(item.createdAt).toLocaleString()
              : "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>Product ID:</strong>{" "}
            {item?.product_id ?? product?.id ?? "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>Single Variant ID:</strong> {item?.variant_id ?? "N/A"}
          </Col>

          {/* <Col md={4} className="mb-2">
            <strong>Double Variant ID:</strong> {item?.d_variant_id ?? "N/A"}
          </Col>

          <Col md={4} className="mb-2">
            <strong>Triple Variant ID:</strong> {item?.t_variant_id ?? "N/A"}
          </Col> */}
        </Row>

        <hr />

        <h5 className="mb-3">Product Details</h5>

        <Row className="mb-3">
          <Col md={3} className="mb-3">
            {product?.image ? (
              <img
                src={getImageUrl(product.image)}
                alt={product?.name || "Product"}
                onClick={() => onImageClick?.(getImageUrl(product.image))}
                style={{
                  width: "100%",
                  maxWidth: "180px",
                  height: "180px",
                  objectFit: "contain",
                  cursor: "pointer",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  padding: "5px",
                }}
              />
            ) : (
              <div>No Product Image</div>
            )}

            <small className="text-muted d-block mt-1">
              Click image to preview
            </small>
          </Col>

          <Col md={9}>
            <p>
              <strong>Product Name:</strong> {product?.name || "N/A"}
            </p>

            <p>
              <strong>Product ID:</strong>{" "}
              {product?.id ?? item?.product_id ?? "N/A"}
            </p>

            <p>
              <strong>Item Code:</strong> {product?.item_code || "N/A"}
            </p>

            <p>
              <strong>Selected Variant Price:</strong>{" "}
              {formatPrice(selectedProductVariant?.price ?? product?.price)}
            </p>

            <p>
              <strong>Selected Variant MRP:</strong>{" "}
              {formatPrice(selectedProductVariant?.mrp ?? product?.mrp)}
            </p>

            <p>
              <strong>Product Status:</strong>{" "}
              <Badge bg={product?.status ? "success" : "secondary"}>
                {product?.status ? "Active" : "Inactive"}
              </Badge>
            </p>
          </Col>
        </Row>

        <hr />

        <h5 className="mb-3">Selected Variant Details</h5>

        {item?.variant_id || singleVariant ? (
          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>Variant Type</th>
                <th>Variant ID</th>
                <th>Variant Option</th>
                <th>Price</th>
                <th>MRP</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Variant</td>
                <td>{singleVariant?.id ?? item?.variant_id ?? "N/A"}</td>
                <td>{getVariantName(singleVariant)}</td>
                <td>{formatPrice(singleVariant?.price)}</td>
                <td>{formatPrice(singleVariant?.mrp)}</td>
              </tr>
            </tbody>
          </Table>
        ) : item?.d_variant_id || doubleVariant ? (
          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>Variant Type</th>
                <th>Variant ID</th>
                <th>Variant Option</th>
                <th>Price</th>
                <th>MRP</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Variant</td>
                <td>{selectedProductVariant?.id ?? "N/A"}</td>
                <td>{getVariantName(selectedProductVariant)}</td>
                <td>{formatPrice(selectedProductVariant?.price)}</td>
                <td>{formatPrice(selectedProductVariant?.mrp)}</td>
              </tr>

              {/* <tr>
                <td>Double (Selected)</td>
                <td>{doubleVariant?.id ?? item?.d_variant_id ?? "N/A"}</td>
                <td>{getVariantName(doubleVariant)}</td>
                <td>{formatPrice(doubleVariant?.price)}</td>
                <td>{formatPrice(doubleVariant?.mrp)}</td>
              </tr> */}
            </tbody>
          </Table>
        ) : item?.t_variant_id || tripleVariant ? (
          <Table bordered responsive hover>
            <thead>
              <tr>
                <th>Variant Type</th>
                <th>Variant ID</th>
                <th>Variant Option</th>
                <th>Price</th>
                <th>MRP</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Variant</td>
                <td>{selectedProductVariant?.id ?? "N/A"}</td>
                <td>{getVariantName(selectedProductVariant)}</td>
                <td>{formatPrice(selectedProductVariant?.price)}</td>
                <td>{formatPrice(selectedProductVariant?.mrp)}</td>
              </tr>

              {/* <tr>
                <td>Double / Parent</td>
                <td>{selectedDoubleVariant?.id ?? "N/A"}</td>
                <td>{getVariantName(selectedDoubleVariant)}</td>
                <td>{formatPrice(selectedDoubleVariant?.price)}</td>
                <td>{formatPrice(selectedDoubleVariant?.mrp)}</td>
              </tr> */}

              {/* <tr>
                <td>Triple (Selected)</td>
                <td>{tripleVariant?.id ?? item?.t_variant_id ?? "N/A"}</td>
                <td>{getVariantName(tripleVariant)}</td>
                <td>{formatPrice(tripleVariant?.price)}</td>
                <td>{formatPrice(tripleVariant?.mrp)}</td>
              </tr> */}
            </tbody>
          </Table>
        ) : (
          <p className="text-muted">No variant selected for this cart item.</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewCartModal;
